import React from 'react';
import { Link } from 'gatsby';
import { BsArrowUpRight } from 'react-icons/bs';

import { makeTagPath } from '../../paths';
import { SectionHeader } from './SectionHeader';

const READING_LISTS = [
  {
    label: 'Productivity',
    tagSlug: 'productivity',
    img: '/images/blog-reading-list-photo-1.jpg',
    color: 'dusk-light',
    icon: '/website/logo-v3/icons/paperform_icon_reading_list_gold.svg',
  },
  {
    label: 'Software',
    tagSlug: 'software',
    img: '/images/blog-reading-list-photo-2.jpg',
    color: 'cloud',
    icon: '/website/logo-v3/icons/paperform_icon_reading_list_salmon.svg',
  },
  {
    label: 'Inspiration',
    tagSlug: 'inspiration',
    img: '/images/blog-reading-list-photo-3.jpg',
    color: 'yellow',
    icon: '/website/logo-v3/icons/paperform_icon_reading_list_green.svg',
  },
];

export function ReadingListCard({ label, tagSlug, img, color, icon }) {
  return (
    <Link
      to={makeTagPath(tagSlug, 1)}
      className={`flex flex-col p-2 w-80 rounded-[23px] relative bg-${color}`}
    >
      <div className="flex flex-col">
        <img className="rounded-[13px] m-0 w-full h-60" src={img} />

        <div className="p-1 pt-3">
          <div className="flex justify-between items-center px-2">
            <span className="text-black font-sonoma font-light">{label}</span>
            <BsArrowUpRight color="black" width={16} />
          </div>
        </div>
      </div>

      <img className="w-10 absolute right-10 bottom-4" src={icon} />
    </Link>
  );
}

export function BlogReadingList() {
  return (
    <>
      <SectionHeader label="Reading Lists" />
      <div className="flex flex-wrap justify-center gap-8 mb-4">
        {READING_LISTS.map((props, i) => (
          <ReadingListCard key={i} {...props} />
        ))}
      </div>
    </>
  );
}
